import { GET_SYSTEM_STATUS, GET_SYSTEM_STATUS_SUCCESS, GET_SYSTEM_STATUS_ERROR} from './actionTypes';

const initialState = {
    errorGetSystemStatus: "",
    loadingGetSystemStatus: false,
    successGetSystemStatus: ""
}

const getSystemStatus = (state = initialState, action) => {
    switch (action.type) {
        case GET_SYSTEM_STATUS:
            state = {
                ...state,
                loadingGetSystemStatus: true
            }
            break;
        case GET_SYSTEM_STATUS_SUCCESS:
            state = {
                ...state,
                loadingGetSystemStatus: false,
                successGetSystemStatus: action.payload.message,
                taskStatus: action.payload.task_status
            }
            break;
        case GET_SYSTEM_STATUS_ERROR:
            state = { ...state, errorGetSystemStatus: action.payload, loadingGetSystemStatus: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getSystemStatus;